import moment from "moment/moment";
import html2canvas from "html2canvas"
import jsPDF from "jspdf"

// *Email Regex
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

// *Password Regex
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_~=@#$>.<,[{}()!%\|'"`:;+*?&])[A-Za-z\d_~=@#$>.<,[{}()!%\|'"`:;+*?&]{8,}$/

// *Mobile Regex
// export const mobileRegex = /^(\+92)?(0)?3[0-9]{9}$/  //* Old Regex
export const mobileRegex = /^(\+92)[0-9]{10}$/

// *Manufacturer Type Id
export const ManufacturerTypeId = 2

// *Drop Shipper Type Id
export const DropShipperTypeId = 3

// *Supplier Type Id
export const SupplierTypeId = 4

// *Guest Buyer Type Id
export const GuestBuyerTypeId = 5

// *For Users Role Ids
export const AdminRoleId = 1
export const ProductManagerRoleId = 2
export const AccountantRoleId = 3
export const MarketingManagerRoleId = 4
export const OrderManagerRoleId = 5

// *Capitalize
export const Capitalize = (str) => {
  const array = str.split(" ");

  for (var i = 0; i < array.length; i++) {
    array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1);
  }
  const capitalString = array.join(" ");
  return capitalString
}

// *For Date Format
export const getDateFormate = (date) => {
  if (!date) return
  const newDate = moment(date).format('YYYY-MM-DD')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDate = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MM-YYYY')
  if (newDate === 'Invalid date') {
    return ''
  }
  return newDate
}

export const getDateTime = (date) => {
  if (!date) return
  const newDate = moment(date).format('DD-MMM-YYYY  h:mm A')
  return newDate
}

// *For Generate PDF
export const GeneratePDF = (content, filename) => {
  html2canvas(content, { scrollX: 0, scrollY: 0 }).then(canvas => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    const pdfWidth = pdf.internal.pageSize.getWidth();
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, 0);
    pdf.save(`${filename}.pdf`);
  });
}

// *For Convert to Title Case
export const convertToTitleCase = (str) => {
  if (str) {
    str = str?.replace(/_/g, ' ');

    let words = str.split(' ');

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].substring(1);
    }

    return words.join(' ');
  }
}
